export default __webpack_public_path__ + "static/reuse-feature-flag-for-experiment-light-mode-f964421e4808c9b50bb80273ea2c2db6.png";